define('modules/lp_leads/views/defaults_popup',['require','exports','module','backbone','common/views/modal_view','ldsh!../templates/defaults_popup'],function(require, exports, module){
  "use strict";

  var Backbone = require("backbone"),
      ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/defaults_popup"),
    triggers: {
      "click .js-close": "close",
      "click .js-cancel": "close",
    },
    defaultFormFields: ["ip_address", "http_user_agent", "http_referer", "url_access", "url", "confirmation_url", "variant_name", "page_id", "variant_id", "visit_id"],
    helpers: function() {
      return {
        fields: this.defaultFormFields
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  },{
    show: function(fields) {
      var model = new Backbone.Model(fields),
          popup = new module.exports({model: model});
      popup.on("close", popup.hide, popup);
    }
  });
});

